/**
 * Returns a protocol field only when it is a string, so truncated or missing
 * device responses can safely flow through every parser.
 */
export function getProtocolString(protocol, key) {
  return protocol && typeof protocol[key] === "string" ? protocol[key] : "";
}
